import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { RouteParamsRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type DeleteChatroomRequest = paths['/chatrooms/{id}']['delete']['parameters']['path'];

export const deleteChatroom = async ({ routeParams: { id } }: RouteParamsRequest<DeleteChatroomRequest>) =>
  getNodeApiAxiosInstance().delete<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(routes.chatrooms.delete(id));
